class ImpactSlide extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slide();
  }

  slide() {
    var elem = this;
    var flkty = new Flickity(elem, {
      // options
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: true
    });
  }
}
customElements.define("impact-slide", ImpactSlide);